import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import type { UserQuotaMetrics, PaginatedUserQuotaData } from "./types";

export async function getDashboardMetrics(): Promise<UserQuotaMetrics> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.get<UserQuotaMetrics>(
            `${process.env.REACT_APP_BACKEND_URL}/user-quota/metrics`,
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard metrics:", error);
        throw new Error("Error fetching dashboard metrics");
    }
}

export async function getPaginatedUsers(
    page = 1,
    limit = 20,
    search = "",
    sortBy?: string,
    sortDirection?: "asc" | "desc"
): Promise<PaginatedUserQuotaData> {
    try {
        const headers = await getAuthHeader();

        const params: any = { page, limit, search };
        if (sortBy) {
            params.sortBy = sortBy;
            params.sortDirection = sortDirection || "asc";
        }

        const response = await axios.get<PaginatedUserQuotaData>(
            `${process.env.REACT_APP_BACKEND_URL}/user-quota/`,
            {
                params,
                headers,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching paginated users:", error);
        throw new Error("Error fetching users");
    }
}